import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { TagInputModule } from 'ngx-chips';

import { DBService } from './db.service';
import { CloudStorageService } from './cloud-storage.service';
import { BackendService } from './backend.service';
import { AdminAuthService } from './admin-auth.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { NavComponent } from './nav/nav.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminProfileComponent } from './admin/admin-profile/admin-profile.component';

import { ForumsListComponent } from './forums/forums-list/forums-list.component';
import { ForumFormModalComponent } from './forums/forum-form-modal/forum-form-modal.component';
import { ShowForumComponent } from './forums/show-forum/show-forum.component';
import { ShowPostComponent } from './forums/show-post/show-post.component';
import { PostFormModalComponent } from './forums/post-form-modal/post-form-modal.component';
import { CommentFormModalComponent } from './forums/comment-form-modal/comment-form-modal.component';

import { CompanyListComponent } from './companies/company-list/company-list.component';
import { ShowCompanyComponent } from './companies/show-company/show-company.component';
import { CompanyFormModalComponent } from './companies/company-form-modal/company-form-modal.component';

import { MemberListComponent } from './members/member-list/member-list.component';
import { ShowMemberComponent } from './members/show-member/show-member.component';
import { MemberFormModalComponent } from './members/member-form-modal/member-form-modal.component';
import { InviteMemberModalComponent } from './members/invite-member-modal/invite-member-modal.component';

import { NewsFeedComponent } from './news-feed/news-feed.component';

import { ProviderListComponent } from './providers/provider-list/provider-list.component';
import { ProviderFormModalComponent } from './providers/provider-form-modal/provider-form-modal.component';
import { ShowProviderComponent } from './providers/show-provider/show-provider.component';

import { EventListComponent } from './calendar/event-list/event-list.component';
import { EventFormModalComponent } from './calendar/event-form-modal/event-form-modal.component';
import { ShowEventComponent } from './calendar/show-event/show-event.component';

import { ResourcesListComponent } from './resources/resources-list/resources-list.component';
import { ResourceFormModalComponent } from './resources/resource-form-modal/resource-form-modal.component';
import { ShowResourceComponent } from './resources/show-resource/show-resource.component';

import { NewslettersListComponent } from './newsletter/newsletters-list/newsletters-list.component';
import { NewsletterFormModalComponent } from './newsletter/newsletter-form-modal/newsletter-form-modal.component';
import { ShowNewsletterComponent } from './newsletter/show-newsletter/show-newsletter.component';

import { SurveysListComponent } from './surveys/surveys-list/surveys-list.component';
import { SurveyFormModalComponent } from './surveys/survey-form-modal/survey-form-modal.component';

import { ReversePipe } from './pipes/reverse.pipe';
import { SummarizePipe } from './pipes/summarize.pipe';
import { FilesizePipe } from './pipes/filesize.pipe';
import { TinymceComponent } from './shared/tinymce/tinymce.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';

import { FbSrcDirective } from './fb-src.directive';
import { UsernameDirective } from './shared/username.directive';


/* Live Config */
export const firebaseConfig = {
  apiKey: 'AIzaSyBnMSY7qGn7GLqQQcKX3EMEfbiolj6rlYU',
  authDomain: 'masterpoolsguild-dca63.firebaseapp.com',
  databaseURL: 'https://masterpoolsguild-dca63.firebaseio.com/',
  storageBucket: 'gs://masterpoolsguild-dca63.appspot.com'
};

/* Dev Config */
/*export const firebaseConfig = {
  apiKey: 'AIzaSyBjb8HpKEyUtqNj7rAkNCW5rt3Y8vUy0zI',
  authDomain: 'mpg-development.firebaseapp.com',
  databaseURL: 'https://mpg-development.firebaseio.com/',
  storageBucket: 'gs://mpg-development.appspot.com'
};*/

const appRoutes = [
  {
    path:  '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path:  'dashboard',
    component: DashboardComponent
  },
  {
    path:  'admin/profile',
    component: AdminProfileComponent
  },
  {
    path:  'login',
    component: LoginComponent
  },
  {
    path:  'forums',
    component: ForumsListComponent
  },
  {
    path:  'forums/:forumKey/posts/:key',
    component: ShowPostComponent
  },
  {
    path:  'forums/:key',
    component: ShowForumComponent
  },
  {
    path:  'companies',
    component: CompanyListComponent
  },
  {
    path:  'companies/:key',
    component: ShowCompanyComponent
  },
  {
    path:  'vendors',
    component: CompanyListComponent
  },
  {
    path:  'vendors/:key',
    component: ShowCompanyComponent
  },
  {
    path:  'members',
    component: MemberListComponent
  },
  {
    path:  'members/:key',
    component: ShowMemberComponent
  },
  {
    path:  'news-feed',
    component: NewsFeedComponent
  },
  {
    path:  'providers',
    component: ProviderListComponent
  },
  {
    path:  'providers/:key',
    component: ShowProviderComponent
  },
  {
    path:  'calendar',
    component: EventListComponent
  },
  {
    path:  'calendar/:key',
    component: ShowEventComponent
  },
  {
    path:  'resources',
    component: ResourcesListComponent
  },
  {
    path:  'resources/:key',
    component: ShowResourceComponent
  },
  {
    path:  'newsletters',
    component: NewslettersListComponent
  },
  {
    path:  'newsletters/:key',
    component: ShowNewsletterComponent
  },
  {
    path:  'surveys',
    component: SurveysListComponent
  }
];


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavComponent,
    DashboardComponent,
    AdminProfileComponent,
    ForumsListComponent,
    ForumFormModalComponent,
    ShowForumComponent,
    ShowPostComponent,
    PostFormModalComponent,
    CommentFormModalComponent,
    CompanyFormModalComponent,
    CompanyListComponent,
    ShowCompanyComponent,
    MemberListComponent,
    ShowMemberComponent,
    MemberFormModalComponent,
    InviteMemberModalComponent,
    NewsFeedComponent,
    ProviderListComponent,
    ProviderFormModalComponent,
    ShowProviderComponent,
    EventListComponent,
    EventFormModalComponent,
    ShowEventComponent,
    ResourcesListComponent,
    ResourceFormModalComponent,
    ShowResourceComponent,
    NewslettersListComponent,
    NewsletterFormModalComponent,
    ShowNewsletterComponent,
    SurveysListComponent,
    SurveyFormModalComponent,
    ReversePipe,
    SummarizePipe,
    FilesizePipe,
    TinymceComponent,
    SafeHtmlPipe,
    StripHtmlPipe,
    FbSrcDirective,
    UsernameDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    NgxMyDatePickerModule.forRoot(),
    TagInputModule
  ],
  providers: [
    DBService,
    CloudStorageService,
    AdminAuthService,
    BackendService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts